module.exports = __webpack_public_path__ + "static/img/section2-contact-new.ff16dc6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/section2-contact-new.png
// module id = 5aRS
// module chunks = 0